import React from 'react';
import { motion } from 'framer-motion';
import { Loader, Plus } from 'lucide-react';
import ForumThreadCard from './ForumThreadCard';
import { ForumThreadRow } from './forumLabels';

type Props = {
  threads: ForumThreadRow[];
  loading: boolean;
  loadingMore: boolean;
  listHasMore: boolean;
  searchQuery: string;
  categoryLabel?: string;
  onOpenThread: (id: string) => void;
  onLoadMore: () => void;
  onNewTopic: () => void;
};

const ForumThreadList: React.FC<Props> = ({
  threads,
  loading,
  loadingMore,
  listHasMore,
  searchQuery,
  categoryLabel,
  onOpenThread,
  onLoadMore,
  onNewTopic,
}) => {
  if (loading) {
    return (
      <div className="forum-loading">
        <Loader size={32} color="var(--accent-primary)" />
      </div>
    );
  }

  if (threads.length === 0) {
    return (
      <div className="forum-empty-state glow-card">
        <p>
          {searchQuery.trim()
            ? 'Aramanızla eşleşen konu bulunamadı.'
            : categoryLabel
              ? `${categoryLabel} kategorisinde henüz konu yok.`
              : 'Henüz konu yok.'}
        </p>
        <motion.button type="button" whileTap={{ scale: 0.98 }} className="forum-btn forum-btn--primary" onClick={onNewTopic}>
          <Plus size={16} /> İlk konuyu aç
        </motion.button>
      </div>
    );
  }

  return (
    <div className="forum-thread-list">
      {threads.map((t) => (
        <ForumThreadCard key={t._id} thread={t} onClick={() => onOpenThread(t._id)} />
      ))}
      {listHasMore && (
        <motion.button
          type="button"
          whileTap={{ scale: 0.98 }}
          className="forum-load-more"
          onClick={onLoadMore}
          disabled={loadingMore}
        >
          {loadingMore ? 'Yükleniyor…' : 'Daha fazla göster'}
        </motion.button>
      )}
    </div>
  );
};

export default ForumThreadList;
